'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';

// Selectors
const selector = {
  graduation: '.js-graduation',
  graduationImage: '.js-graduation__image',
  graduationValue: '.js-graduation__value',
  graduationList: '.js-graduation-list',
  graduationListItem: '.js-graduation-list__item'
};

// Variables
const eventChange = new Event('change');

// Class definition for Graduations List
export default class GraduationsList {
  constructor(fields) {
    Object.assign(this, fields); // Assign fields to this object

    this.graduation = this.wrapper.querySelector(selector.graduation);
    this.graduationList = this.wrapper.querySelector(selector.graduationList);
    this.graduationListItems = this.graduationList
      ? this.graduationList.querySelectorAll(selector.graduationListItem)
      : null;
    this.graduationListItemDefault =
      this.input.value && this.graduationList
        ? this.graduationList.querySelector(
            `[data-value="${this.input.value}"]`
          )
        : null;
  }

  /**
   * Init the graduations list
   * @returns {void}
   */
  init() {
    if (
      this.graduation &&
      this.input &&
      this.graduationList &&
      this.graduationListItems
    ) {
      // Open the list when clicking on the input
      listenDOMEvent(this.graduation, 'click', this.openList.bind(this));

      // Update the input value when clicking on a list item
      this.graduationListItems.forEach((graduationListItem) => {
        listenDOMEvent(graduationListItem, 'click', () => {
          this.selectListItem(graduationListItem);
        });
      });

      // Close the list when clicking outside
      listenDOMEvent(window, 'click', (event) => {
        if (
          !event.target.closest(selector.graduationList) &&
          !event.target.closest(selector.graduationListItem) &&
          !event.target.closest(selector.graduation)
        ) {
          this.closeList();
        }
      });

      // Set default value
      if (this.graduationListItemDefault) {
        this.graduationListItemDefault.dispatchEvent(new Event('click'));
      }
    } else {
      console.error('Missing elements for graduations list');
    }
  }

  /**
   * Open the list of graduations
   * @returns {void}
   */
  openList() {
    if (
      this.graduationList &&
      !hasClassElement(this.wrapper, classes.is.disabled)
    ) {
      removeClassToElement(this.graduationList, classes.hidden);
    }
  }

  /**
   * Close the list of graduations
   * @returns {void}
   */
  closeList() {
    if (this.graduationList) {
      addClassToElement(this.graduationList, classes.hidden);
    }
  }

  /**
   * Select a graduation from the list
   * @param {HTMLElement} selectedItem - The selected item with data of the graduation
   * @returns {void}
   */
  selectListItem(selectedItem) {
    const value = selectedItem.dataset.value;
    const valueFake = selectedItem.dataset.valueFake;
    const graduationValueFakeElement = this.graduation
      ? this.graduation.querySelector(selector.graduationValue)
      : null;

    if (this.input) {
      this.input.value = value;
    }

    if (graduationValueFakeElement && valueFake) {
      graduationValueFakeElement.textContent = valueFake;
    }

    this.input.dispatchEvent(eventChange);
    this.closeList();
  }
}
